module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item7-ab21eb6d5d6c97789083b668fd6b29f9.svg";